import React from "react";

type Props = {
  message: string;
};

/**
 * Shown when Auth0 bootstrap fails before the main app mounts.
 */
export function BootstrapError({ message }: Props) {
  return (
    <div className="mx-auto my-8 max-w-2xl p-8 font-sans">
      <h1 className="mb-4 text-xl font-semibold text-red-600">
        Configuration error
      </h1>
      <p className="text-gray-800">{message}</p>
      <p className="mt-4 text-sm text-gray-500">
        Set REACT_APP_DOMAIN, REACT_APP_CLIENT_ID, and REACT_APP_AUDIENCE in{" "}
        <code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-sm">
          .env
        </code>{" "}
        (see .env.example if available).
      </p>
    </div>
  );
}
